module.exports = __webpack_public_path__ + "static/logo-025e4c1b961fb5faa6a9b8f579d21001.svg";